const irregularPlurals: Record<string, string> = {
  was: 'were',
  is: 'are',
};

export default function pluralize(
  value: string | null,
  count: number | undefined
) {
  if (!value) return '';
  if (count && count === 1) return value;

  const fromDictionary = irregularPlurals[value];
  return fromDictionary ? fromDictionary : `${value}s`;
}
